import React from "react";
import { Box, Typography } from "@mui/material";
import { renderTruncatedText } from "../../../core/Constant";

const DocumentBreadcrumbs = ({ breadcrumbTrail = [], onBreadcrumbClick }) => {
  return (
    <Box sx={{ mt: 1.5, mb: 2, display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {breadcrumbTrail.map((crumb, index) => {
        const isLast = index === breadcrumbTrail.length - 1;
        const isClickable = !isLast
        return (
          <Box
            key={`${crumb.id ?? "root"}-${index}`}
            sx={{ display: "flex", alignItems: "center" }}
          >
            {index > 0 && (
              <Typography sx={{ mx: 0.75, color: "#9AA5B1" }}>
                {">"}
              </Typography>
            )}
            <Typography
              onClick={() => isClickable && onBreadcrumbClick(index, crumb)}
              sx={{
                fontSize: 14,
                color: isLast ? "#1a1a1a" : "#9AA5B1",
                fontWeight: isLast ? 700 : 400,
                cursor: isClickable ? "pointer" : "default",
                fontFamily: "Montserrat",
                "&:hover": isClickable ? { color: "#9834F0" } : {},
              }}
            >
              {renderTruncatedText(crumb.name, { limit: 40 })}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default DocumentBreadcrumbs;